import { css, Global } from "@emotion/react";

const globalStyles = css`
  .ant-input-borderless.ant-input-disabled,
  .ant-input-borderless[disabled] {
    color: inherit !important;
  }

  .ant-input-outlined.ant-input-disabled,
  .ant-input-outlined[disabled] {
    background-color: #fff !important;
    color: #000 !important;
  }
`;
const SC = {
  GlobalStyles: <Global styles={globalStyles} />,
};
export default SC;
